module.exports = __webpack_public_path__ + "static/media/productSafe.96354ff6.png";